import { network } from 'services/network';
import { useQuery } from 'react-query';

const getPermLink = (params) => {
    const url = `api/bo/getActivityMainDetailsByTaskdId?taskId=${params}`;

    return network
        .get(url)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

export const useQueryActivityDetailsByTaskdId = (params) => {
    return useQuery<IActivityDetailsResponse, QueryError>(['createUserAction', params], () => getPermLink(params), {
        enabled: Boolean(params),
    });
};

export interface IActivityDetailsResponse {
    activityId: number;
    activityName: string;
    wbsId: number;
    wbsName: string;
    versionName: string;
    versionDate: number;
    versionId: number;
    projectId: number;
    projectName: string;
    subProgramId: number;
    subProgramName: string;
}
